import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import OwnerCell from '../owner-cell';
// Import Actions
import { fetchOrganizationManagers } from '../../modules/Auth/AuthActions';

// Import Selectors
import { getManagers } from '../../modules/Auth/AuthReducer';

class ManagerList extends Component {
  constructor() {
    super();
    this.state = {};
  }

  componentDidMount() {
    this.props.dispatch(fetchOrganizationManagers());
  }

  render() {
    const { managers } = this.props;
    const { items } = managers;
    return (
      <div>
        {items.length > 0 &&
          <div>
            <p>
              The manager(s) for your organization include:
            </p>
            <ul className="list-group">
              {items.map(item => (
                <li className="list-group-item" key={item._id}>
                  <OwnerCell owner={item} showFullEmail clickableFullEmail fixWidth={false} />
                </li>
              ))}
            </ul>
          </div>
        }
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    managers: getManagers(state),
  };
}

ManagerList.propTypes = {
  dispatch: PropTypes.func.isRequired,
  managers: PropTypes.shape({
    items: PropTypes.array,
    meta: PropTypes.object,
  }).isRequired,
};

export default connect(mapStateToProps)(ManagerList);
